/* eslint-disable */
import saveStoreDraft from "../../utils/saveStoreDraft";
import useStoreFormDraft from "../../hooks/useStoreFormDraft";
import { useTranslation as useUiTranslation } from "react-i18next";
import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { doc } from "firebase/firestore";
import { db } from "../../firebase";
import { useSelector } from "react-redux";

function Sawa9lyModal() {
  const { t: uiT } = useUiTranslation();
  const { code } = useParams();
  const isCodeLong = code && code.length > 10;
  const navigate = useNavigate();
  const store = useSelector((state) => state.StoreReducer);
  const [storeData, setStoreData] = useStoreFormDraft(store);

  const handleAccept = async () => {
    try {
      const response = await fetch("https://sawa9ly.app/api/v1/foorweb/check", {
        method: "GET",
        headers: {
          Authorization: `Bearer ${code}`,
          Accept: "application/json",
        },
      });

      const result = await response.json();

      if (response.ok) {
        const updatedData = {
          ...storeData,
          sawa9lyToken: code,
        };

        await saveStoreDraft(doc(db, "store", storeData.id), store, updatedData);

        window.location.href = `https://sawa9ly.app/foorweb/${code}`;
      } else {
        console.warn("❌ الكود غير صالح:", result);
        alert(uiT("ui.codeInvalidExpired"));
      }
    } catch (error) {
      console.error("خطأ في الاتصال بالسيرفر:", error);
      alert(uiT("ui.codeCheckError"));
    }
  };

  const handleRefuse = () => {
    navigate("/dashboard");
  };

  const displayCode = isCodeLong
    ? `${code.substring(0, 8)}...${code.slice(-2)}`
    : code;

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        backgroundColor: "rgba(0, 0, 0, 0.7)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
        direction: "rtl",
        backdropFilter: "blur(3px)",
        transition: "all 0.3s ease",
      }}
    >
      <div
        style={{
          background: "linear-gradient(145deg, #ffffff, #f8f9fa)",
          padding: "2.5rem",
          borderRadius: "1.5rem",
          width: "400px",
          maxWidth: "95%",
          textAlign: "center",
          boxShadow: "0 15px 30px rgba(0,0,0,0.25)",
          border: "1px solid rgba(255,255,255,0.2)",
          transform: "scale(1)",
          animation: "fadeIn 0.3s ease-out",
        }}
      >
        <h2
          style={{
            marginBottom: "1.5rem",
            color: "#2c3e50",
            fontSize: "1.5rem",
            fontWeight: "600",
          }}
        >
          {uiT("ui.connectSawa9ly")}
        </h2>

        <p
          style={{
            marginBottom: "1.5rem",
            color: "#555",
            lineHeight: "1.6",
            fontSize: "1.1rem",
          }}
        >
          {uiT("ui.sawa9lyConfirm")}
        </p>

        <div
          style={{
            position: "relative",
            background: "#f1f5f9",
            padding: "1rem",
            borderRadius: "0.75rem",
            margin: "0 auto 2rem",
            width: "fit-content",
            maxWidth: "100%",
            boxShadow: "inset 0 2px 4px rgba(0,0,0,0.05)",
            overflow: "hidden",
          }}
        >
          <div style={{ position: "relative", display: "inline-block" }}>
            <code
              style={{
                fontFamily: "'Courier New', monospace",
                fontWeight: "bold",
                fontSize: "1.3rem",
                color: "#0f172a",
                backgroundColor: "#e2e8f0",
                padding: "0.5rem 1rem",
                borderRadius: "0.5rem",
                letterSpacing: "1px",
                filter: "blur(5px)",
                cursor: "not-allowed",
                transition: "filter 0.3s ease",
                userSelect: "none",
              }}
            >
              {displayCode}
            </code>
          </div>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "1.5rem",
            marginTop: "1.5rem",
          }}
        >
          <button
            onClick={handleAccept}
            style={{
              padding: "0.75rem 1.75rem",
              background: "linear-gradient(135deg, #10b981, #059669)",
              color: "#fff",
              border: "none",
              borderRadius: "0.75rem",
              cursor: "pointer",
              fontSize: "1rem",
              fontWeight: "600",
              boxShadow: "0 4px 6px rgba(5, 150, 105, 0.3)",
              transition: "all 0.2s ease",
              flex: 1,
              maxWidth: "150px",
            }}
            onMouseOver={(e) =>
              (e.currentTarget.style.transform = "translateY(-2px)")
            }
            onMouseOut={(e) =>
              (e.currentTarget.style.transform = "translateY(0)")
            }
          >
            {uiT("ui.confirmConnect")}
          </button>
          <button
            onClick={handleRefuse}
            style={{
              padding: "0.75rem 1.75rem",
              background: "linear-gradient(135deg, #ef4444, #dc2626)",
              color: "#fff",
              border: "none",
              borderRadius: "0.75rem",
              cursor: "pointer",
              fontSize: "1rem",
              fontWeight: "600",
              boxShadow: "0 4px 6px rgba(220, 38, 38, 0.3)",
              transition: "all 0.2s ease",
              flex: 1,
              maxWidth: "150px",
            }}
            onMouseOver={(e) =>
              (e.currentTarget.style.transform = "translateY(-2px)")
            }
            onMouseOut={(e) =>
              (e.currentTarget.style.transform = "translateY(0)")
            }
          >
            {uiT("ui.cancelConnect")}
          </button>
        </div>
      </div>
    </div>
  );
}

export default Sawa9lyModal;
